import React from 'react'
import OldQCNoteTable from 'components/OldQcNoteTable'
import NewQCNoteTable from 'components/NewQcNoteTable'
import { StyledAddMoreButton } from 'components/NewQcNoteTable/styled'
import { StyledDiv } from './styled'
import { createDefaultQcNotes } from './utils'

const QCNoteTable = ({ oldQcNotes = [], newQcNotes = [], setNewQcNotes }) => {
  const onAddMoreRows = () => {
    const NewQcNotes = createDefaultQcNotes()
    setNewQcNotes([...newQcNotes, NewQcNotes])
  }
  return (
    <StyledDiv>
      <OldQCNoteTable qcNotes={oldQcNotes} />
      {newQcNotes.length > 0 && (
        <NewQCNoteTable newQcNotes={newQcNotes} setNewQcNotes={setNewQcNotes} />
      )}
      <StyledAddMoreButton onClick={onAddMoreRows}>
        Add More
      </StyledAddMoreButton>
    </StyledDiv>
  )
}

export default QCNoteTable
